import { create } from 'zustand';
import { immer } from 'zustand/middleware/immer';
import { persist, createJSONStorage } from 'zustand/middleware';
import moment from 'moment-jalaali';

const initialState = {
  filters: {
    customer: false,
    driver: false,
  },
  userFilters: {},
  users: null,
  page: 1,
  isLoading: false,
  startDate: moment(),
  endDate: moment(),
  selectedUser: null,
  userStartDate: moment(),
  userEndDate: moment(),
  userPage: 1,
  isLoadingUser: false,
  totalCustomers: 0,
};
export const useOnlineUsersStore = create(
  persist(
    immer((set, get) => ({
      ...initialState,
      changeCheckBox: (name, checked) =>
        set((state) => {
          state.filters[name] = checked;
        }),
      setUsers: (users) =>
        set((state) => {
          state.users = users;
        }),
      setLoading: (payload) =>
        set((state) => {
          state.isLoading = payload;
        }),
      changePage: (page) =>
        set((state) => {
          state.page = page;
        }),
      changeStartDate: (date) =>
        set((state) => {
          state.startDate = date;
        }),
      changeEndDate: (date) =>
        set((state) => {
          state.endDate = date;
        }),
      setUserLoading: (payload) =>
        set((state) => {
          state.isLoadingUser = payload;
        }),
      changeUserStartDate: (date) =>
        set((state) => {
          state.userStartDate = date;
        }),
      changeUserEndDate: (date) =>
        set((state) => {
          state.userEndDate = date;
        }),
      changeUserPage: (page) =>
        set((state) => {
          state.userPage = page;
        }),
      setSelectedUser: (user) =>
        set((state) => {
          state.selectedUser = user;
        }),
      setTotalCustomers: (data) =>
        set((state) => {
          state.totalCustomers = data;
        }),
    })),
    {
      name: '@footab/admin/onlineUsers',
      storage: createJSONStorage(() => sessionStorage),
      partialize: (state) =>
        Object.fromEntries(
          Object.entries(state).filter(
            ([key]) => !['users', 'selectedUser'].includes(key)
          )
        ),
    }
  )
);
